import { Gauge, Cpu, CircuitBoard, ShieldOff, KeyRound, Unlock, Binary, Key } from "lucide-react";

export const ICONS = { Gauge, Cpu, CircuitBoard, ShieldOff, KeyRound, Unlock, Binary, Key };

export function ServiceIcon({ name, className }) {
  const Cmp = ICONS[name] || Gauge;
  return <Cmp className={className} />;
}
